import debitorIndex from './index';

export default () => ({
  link: 'debitor',
  Handler: debitorIndex,
});
